import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Download, FileText } from "lucide-react";
import { DEFAULT_DOWNLOADS, IMAGES } from "@/lib/constants";
import { PageBanner } from "@/components/PageBanner";
import { api } from "@/lib/api";

export default function Downloads() {
  const [items, setItems] = useState(DEFAULT_DOWNLOADS);

  useEffect(() => {
    api.getDownloads().then((r) => {
      if (r.data.length) setItems([...r.data, ...DEFAULT_DOWNLOADS]);
    }).catch(() => {});
  }, []);

  const handle = (d) => {
    if (d.url) window.open(d.url, "_blank");
    else toast.info("This file will be available soon. Please contact the school office.");
  };

  return (
    <div>
      <PageBanner title="Downloads" subtitle="Download admission forms, prospectus, holiday list, syllabus and more." image={IMAGES.smartClass} />
      <section className="max-w-5xl mx-auto px-6 py-20">
        <div className="grid sm:grid-cols-2 gap-5">
          {items.map((d, i) => (
            <button key={i} onClick={() => handle(d)} data-testid={`download-item-${i}`}
              className="group flex items-center gap-4 bg-white rounded-2xl p-5 border border-slate-200 shadow-sm hover:shadow-md hover:border-brandred transition-transform text-left">
              <div className="h-12 w-12 rounded-xl bg-brandred/10 text-brandred grid place-items-center shrink-0 group-hover:bg-brandred group-hover:text-white transition-colors"><FileText className="h-6 w-6" /></div>
              <div className="flex-1">
                <h4 className="font-head font-bold text-navy">{d.title}</h4>
                <p className="text-xs text-slate-500">{d.description || d.category}</p>
              </div>
              <Download className="h-5 w-5 text-slate-400 group-hover:text-brandred" />
            </button>
          ))}
        </div>
      </section>
    </div>
  );
}
